import { store } from '@core/Store'
import { post } from '@classic/Foundation/Services/ApiService'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'
import type { KambiPlaceBetRequest, KambiPlaceBetResponse, KambiValidateBetRequest } from './types'

// TODO: Not necessary to copy this, can handle better way?
import { BetResponseCode } from '@core/Data/betting'
const networkErrorMessage = 'Network Error'
const httpStatusToBetResponseCode: Record<number, BetResponseCode | undefined> = {
  401: BetResponseCode.Unauthorized,
  402: BetResponseCode.InsufficientFunds,
  406: BetResponseCode.PriceChanged,
  417: BetResponseCode.HandicapChanged,
}

export const postValidateKambiSportsBet = ({
  couponRows,
  bets,
}: Pick<KambiPlaceBetRequest, 'couponRows' | 'bets'>) => {
  return placeBet<KambiValidateBetRequest>('/api/kambibetting/validate-bet', {
    couponRows,
    bets,
  })
}

let sessionCommitCount = 0

export const postPlaceKambiSportsBet = ({
  couponRows,
  bets,
}: Pick<KambiPlaceBetRequest, 'couponRows' | 'bets'>) => {
  return placeBet<KambiPlaceBetRequest>('/api/kambibetting/place-bet', {
    requestId: `${Date.now()}-${++sessionCommitCount}`,
    couponRows,
    bets,
  })
}

// =============
// Local Helpers
// =============

function placeBet<TRequest>(url: string, request: TRequest): Promise<KambiPlaceBetResponse> {
  const kambiBearerToken = selectPlayerSessionId(store.getState())
  // TODO: Handle login check and refesh token if need be
  if (!kambiBearerToken) {
    throw { code: 'Unauth' }
  }

  const additionalHeaders = { ['X-Kambi-Bearer']: kambiBearerToken }

  return post<KambiPlaceBetResponse>({ url, body: request, additionalHeaders }).catch(
    async error => {
      if (!error.response) {
        throw {
          code: BetResponseCode.NetworkError,
          response: { message: networkErrorMessage },
        }
      }

      const errorResponse = await error.response.json()
      throw {
        code: httpStatusToBetResponseCode[error.response.status] || BetResponseCode.UnknownError,
        response: errorResponse,
      }
    }
  )
}
